import React from 'react';
import { Search, X } from 'lucide-react';
import { SaleReturnViewType } from '../../../types/view.types';

interface SearchHeaderProps {
  view: SaleReturnViewType;
  numpadValue: string;
  searchQuery: string;
  setSearchQuery: (v: string) => void;
  isSearchFocused: boolean;
  setIsSearchFocused: (v: boolean) => void;
  setDetailedBookId: (v: string | null) => void;
}

export const SearchHeader: React.FC<SearchHeaderProps> = ({
  view,
  numpadValue,
  searchQuery,
  setSearchQuery,
  isSearchFocused,
  setIsSearchFocused,
  setDetailedBookId,
}) => {
  return (
    <div className="search-header-container">
      <div className="search-header-numpad-group">
        <span className="search-header-numpad-value">
          {numpadValue ? (
            numpadValue
          ) : (
            <span className="search-header-numpad-empty">
              {view === 'returns' ? 'ID TICKET' : 'ISBN / SKU'}
            </span>
          )}
        </span>
        {numpadValue && (
          <span className="search-header-numpad-sub">
            {view === 'returns' ? 'Búsqueda de ticket' : 'Búsqueda manual'}
          </span>
        )}
      </div>

      <div className="search-input-wrapper group">
        <Search
          className={`search-input-icon ${
            searchQuery ? 'search-input-icon-active' : 'search-input-icon-inactive'
          }`}
        />
        <input
          type="text"
          placeholder={view === 'returns' ? 'Buscar factura por ID o nº...' : 'Buscar Título o Autor...'}
          className="search-input-field"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          onFocus={() => setIsSearchFocused(true)}
        />
        {(searchQuery || isSearchFocused) && (
          <button
            onClick={() => {
              setSearchQuery('');
              setIsSearchFocused(false);
              setDetailedBookId(null);
            }}
            className="search-input-clear"
          >
            <X className="w-4 h-4" />
          </button>
        )}
      </div>
    </div>
  );
};
